window.addEventListener("error", (event) => {
	if (event.message.toLowerCase().includes("chunk")) {
		console.warn("Script loading failed. Reloading page.");
		location.reload();
	}
});

window.addEventListener("unhandledrejection", (event) => {
	const reason = event.reason?.message?.toLowerCase() || "";
	if (
		reason.includes("loading chunk") ||
		reason.includes("fetch") ||
		reason.includes("failed to fetch")
	) {
		console.warn("Chunk loading failed. Reloading page.");
		location.reload();
	}
});

import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch((err) => console.error(err));
